import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

class ReviewStepRow extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.node,
  };

  render() {
    const { label, value } = this.props;

    return (
      <div className={styles.row}>
        <span className={styles.rowLabel}>{label}</span>
        <span className={styles.rowValue}>{value}</span>
      </div>
    );
  }
}

export default ReviewStepRow;



// WEBPACK FOOTER //
// ./src/components/ReviewStepRow/index.js